module.exports = {template: '<svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.006 5.882h9.17a.588.588 0 1 0 0-1.176h-9.17l3.117-3.118a.588.588 0 1 0-.835-.823L.171 4.882a.588.588 0 0 0 0 .824l4.117 4.118A.588.588 0 0 0 5.123 9L2.006 5.882z" fill="#232323"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/arrow.svg
// module id = 554
// module chunks = 1